module.exports = __webpack_public_path__ + "img/NUSLogo.9b7ecaf4.png";